export default {
      id: "close-outline-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons-sprite.03ac376.svg#close-outline-usage",
      toString: function () {
        return this.url;
      }
    }